import { render, staticRenderFns } from "./Pinterest.vue?vue&type=template&id=55302ac8"
import script from "./Pinterest.vue?vue&type=script&lang=js"
export * from "./Pinterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports